import addDays from 'date-fns/addDays';
import differenceInWeeks from 'date-fns/differenceInWeeks';
import getDay from 'date-fns/getDay';
import isWeekend from 'date-fns/isWeekend';
import isAfter from 'date-fns/isAfter';
import subDays from 'date-fns/subDays';

// --------- Deal with business days (handle holidays & weekends) -------

export const addBusinessDays = (d, inc, cal) => {
  let date;
  if (inc === 0) return d;
  if (inc === 1) {
    date = addWeekDays(d, 1);
    while (cal && cal.isHoliday(date)) {
      date = addWeekDays(date, 1);
    }
    return date;
  }
  date = addWeekDays(d, inc);
  if (cal) {
    const holidayCount = cal.holidaysInRange(d, date);
    for (let i=0; i<holidayCount; i++) {
      date = addWeekDays(date, 1);
      while (cal.isHoliday(date)) {
        date = addWeekDays(date, 1);
      }
    }
  }
  return date;
};

export const subtractBusinessDays = (d, inc, cal) => {
  let date;
  if (inc === 0) return d;
  if (inc === 1) {
    date = subtractWeekDays(d, 1);
    while (cal && cal.isHoliday(date)) {
      date = subtractWeekDays(date, 1);
    }
    return date;
  }
  date = subtractWeekDays(d, inc);
  if (cal) {
    const holidayCount = cal.holidaysInRange(date, d);
    for (let i=0; i<holidayCount; i++) {
      date = subtractWeekDays(date, 1);
      while (cal.isHoliday(date)) {
        date = subtractWeekDays(date, 1);
      }
    }
  }
  return date;
};

export const firstBusinessDay = (d, cal) => {
  let date = firstWeekDay(d);
  while (cal && cal.isHoliday(date)) {
    date = addWeekDays(date, 1);
    date = firstWeekDay(date);
  }
  return date;
};

// Returns business days in date range (inclusive of endDate and startDate)
export const businessDaysInRange = (endDate, startDate, cal) => {
  const end = firstBusinessDay(endDate, cal);
  const start = firstBusinessDay(startDate, cal);
  const weekDays = differenceInWeekDays(end, start);
  const holidays = cal ? cal.holidaysInRange(start, end) : 0;
  return weekDays - holidays;
}

// --------- Deal with week days (handle weekends only) -------

export const addWeekDays = (d, inc) => {
  if (inc === 0) return d;
  const increment = inc / Math.abs(inc);
  let date = addDays(d, Math.floor(Math.abs(inc) / 5) * 7 * increment);

  let remaining = inc % 5;
  while (remaining !== 0) {
    date = addDays(date, increment);
    if (!isWeekend(date)) {
      remaining -= increment;
    }
  }
  return date;
};

export const subtractWeekDays = (d, inc) => {
  if (inc === 0) return d;
  const increment = inc / Math.abs(inc);
  let date = subDays(d, Math.floor(Math.abs(inc) / 5) * 7 * increment);

  let remaining = inc % 5;
  while (remaining !== 0) {
    date = subDays(date, increment);
    if (!isWeekend(date)) {
      remaining -= increment;
    }
  }
  return date;
};

export const firstWeekDay = (date) => {
  const day = getDay(date);
  if (day === 0) {
    return addDays(date, 1);
  } else if (day === 6) {
    return addDays(date, 2);
  }
  return date;
};

// start and end days must be week days
// -- returns week days inclusive of start and end
export const differenceInWeekDays = (end, start) => {
  // console.log('differenceInWeekDays: ', end, start);
  // const end = firstBusinessDay(dateLeft);
  // const start = firstBusinessDay(dateRight);
  if (isAfter(start, end)) return -1;
  const startDay = getDay(start);
  const endDay = getDay(end);
  const weeks = differenceInWeeks(end, start);
  let daysInPartialWeeks;
  if (endDay >= startDay) {
    daysInPartialWeeks = endDay - startDay;
  } else {
    daysInPartialWeeks = endDay - startDay + 5;
  }
  const weekDays = (weeks * 5) + daysInPartialWeeks;
  // console.log('weekDays: ', weeks, daysInPartialWeeks, endDay, startDay);
  return weekDays + 1;
};



// WEBPACK FOOTER //
// ./src/shared/helpers/dateHelpers.js